import React, { Component } from "react";
import Loader from "./../../layout/Loader/Loader";

import styles from "./../StepColorSliderHandle.module.scss";

export class StepColorPrimary extends Component {
  state = {
    loading: true,
    primaryColors: null
  };

  static getDerivedStateFromProps(props, state) {
    if (props.primaryColors !== state.primaryColors) {
      const { state } = props;
      
      if (state.primaryColors) {
        return {
          loading: false,
          primaryColors: state.primaryColors
        };
      }
    }
    return null
  }

  render() {
    const { state, setPrimaryColor } = this.props;
    const { loading } = this.state;

    let primaryColorSelected = "0";
    if (state && state.primaryColorSelected) {
      primaryColorSelected = state.primaryColorSelected;
    }

    return (
      <div data-test="StepColorPrimaryComponent">
        <h1 className="d-none d-md-block header-step">
          Tu lipstick personalizado, en segundos
        </h1>
        {loading && (
          <div className="center-xs">
            <Loader />
          </div>
        )}
        <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">
          Elige tu color base
        </h6>
        {state && state.primaryColors && (
          <div className={`${styles.rangeWrap} space-bottom`}>
            <input
              className={styles.rangeInput}
              onChange={ev => setPrimaryColor(ev)}
              type="range"
              id="primaryColorRange"
              step="1"
              min="0"
              max={state.primaryColors.length - 1}
              value={primaryColorSelected}
            />

            <div
              className={styles.rangeColors}
              style={{
                background: `linear-gradient(to right, ${state.primaryColors.join(
                  ","
                )})`
              }}
            ></div>
          </div>
        )}
      </div>
    );
  }
}

export default StepColorPrimary;
